import { useCallback, useEffect, useState, useRef } from "react";
import SVG from "react-inlinesvg";
import dynamic from "next/dynamic";
import { getDataFromSSR } from "@/handlers/client/commonClient";
import { logger } from "@/utils/logging/log-util";
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));

const getInningData = (commData, tab) => {
  switch (tab) {
    case 1:
      return commData?.firstInn;
    case 2:
      return commData?.secondInn;
    case 3:
      return commData?.thirdInn;
    case 4:
      return commData?.fourthInn;
    default:
      return [];
  }
};

const applyFilter = (data, filterTab) => {
  if (!Array.isArray(data)) return [];

  switch (filterTab) {
    case 2:
      return data.map((over) => ({
        balls: over.balls?.filter((ball) => ball.wicket === "Yes"),
        over_summary: [],
      }));
    case 3:
      return data.map((over) => ({
        balls: over.balls?.filter((ball) => ball.runs === "4"),
        over_summary: [],
      }));
    case 4:
      return data.map((over) => ({
        balls: over.balls?.filter((ball) => ball.runs === "6"),
        over_summary: [],
      }));
    default:
      return data;
  }
};

const MatchCommentary = ({
  matchData = null,
  commData = null,
  scrolled = false,
  isTest = false,
}) => {
  const getDefaultTab = () => {
    switch (matchData?.currentInning) {
      case "First":
        return 1;
      case "Second":
        return 2;
      case "Third":
        return 3;
      case "Fourth":
        return 4;
      default:
        return 1;
    }
  };
  const tempCommData = commData;
  const [currentTab, setCurrentTab] = useState(getDefaultTab());
  const [activeCommTab, setActiveCommTab] = useState(1);
  const [commentary, setCommentary] = useState(() =>
    applyFilter(getInningData(tempCommData, getDefaultTab()), 1)
  );

  const intervalRef = useRef(null);

  const updateCommentary = useCallback(
    (data) => {
      const inningData = getInningData(data, currentTab);
      const filtered = applyFilter(inningData, activeCommTab);
      setCommentary(filtered || []);
    },
    [currentTab, activeCommTab]
  );

  // Live commentary polling
  useEffect(() => {
    if (matchData?.status !== "LIVE") return;

    const fetchLiveCommentary = async () => {
      try {
        const timeStamp = Date.now();
        const comms = await getDataFromSSR(
          `/api/getLiveCommentary?matchid=${matchData.id}&inn=${isTest ? matchData?.currentInning || 1 : 1
          }&time=${timeStamp}`
        );
        if (comms?.data) updateCommentary(comms.data);
      } catch (err) {
        logger.error(err);
        setCommentary([]);
      }
    };

    fetchLiveCommentary(); // Initial load
    intervalRef.current = setInterval(fetchLiveCommentary, 8000);

    return () => clearInterval(intervalRef.current);
  }, [matchData?.id, matchData?.status, updateCommentary]);

  // Static/final match commentary
  useEffect(() => {
    if (matchData?.status !== "LIVE") {
      updateCommentary(commData);
    }
  }, [
    activeCommTab,
    currentTab,
    matchData?.status,
    commData,
    updateCommentary,
  ]);

  const commTabs = [
    { tabNo: 1, tabName: "All" },
    { tabNo: 2, tabName: "W" },
    { tabNo: 3, tabName: "4s" },
    { tabNo: 4, tabName: "6s" },
  ];
  console.log("imagess", matchData);
  return matchData ? (
    <div className="w-full">
      <div className="w-full overflow-x-auto whitespace-nowrap gap-4 flex md:justify-start justify-between md:gap-2 items-center my-4 ">
        {matchData?.inn1_team && (
          <button
            onClick={() => {
              setCurrentTab(1);
              // setActiveCommTab(1);
            }}
            className={`min-w-fit flex items-center gap-1 py-2 px-2 md:px-4 rounded-lg border border-gray-300 ${currentTab == 1 ? "border-primary bg-primary text-white" : ""
              }`}
          >
            <img
              src={
                matchData?.firstInning_image ||
                (matchData?.inn1_team == "IND"
                  ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1126.png"
                  : matchData.inn1_team == "ENG"
                    ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1121.png"
                    : ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${matchData?.inn1_team.toLowerCase()}1.png`)
              }
              width={35}
              height={35}
              alt="teama_logo"
            />
            <div className="flex flex-col gap-1 text-sm">
              <span className="flex items-center gap-2">
                <span>{matchData?.inn1_team}</span>
                <span
                  className={`${currentTab == 1 ? "text-white" : ""
                    }rounded-full bg-gray-400 w-1 h-1`}
                ></span>
                <span
                  className={`${currentTab == 1 ? "text-white" : ""
                    } text-gray-500`}
                >
                  {"1st Inn"}
                </span>
              </span>
              <span>{matchData?.inn1_score || "Yet to Bat"}</span>
            </div>
          </button>
        )}
        {matchData?.inn2_team && (
          <button
            onClick={() => {
              setCurrentTab(2);
              // setActiveCommTab(1);
            }}
            className={`min-w-fit flex items-center gap-2 py-2 px-2 md:px-4 rounded-lg border border-gray-300 ${currentTab == 2 ? "border-primary bg-primary text-white" : ""
              }`}
          >
            <img
              src={
                matchData?.secondInning_image ||
                (matchData?.inn2_team == "IND"
                  ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1126.png"
                  : matchData.inn2_team == "ENG"
                    ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1121.png"
                    : ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${matchData?.inn2_team.toLowerCase()}1.png`)
              }
              width={35}
              height={35}
              alt="teamb_logo"
            />
            <div className="flex flex-col gap-1 text-sm">
              <span className="flex items-center gap-2">
                <span>{matchData?.inn2_team}</span>
                <span
                  className={`${currentTab == 2 ? "text-white" : ""
                    } rounded-full bg-gray-400 w-1 h-1`}
                ></span>
                <span
                  className={`${currentTab == 2 ? "text-white" : ""
                    }text-gray-500`}
                >
                  {"2nd Inn"}
                </span>
              </span>
              <span>{matchData?.inn2_score || "Yet to Bat"}</span>
            </div>
          </button>
        )}
        {matchData?.inn3_team && (
          <button
            onClick={() => {
              setCurrentTab(3);
              // setActiveCommTab(1);
            }}
            className={`min-w-fit flex items-center gap-1 py-2 px-2 md:px-4 rounded-lg border-gray-300 ${currentTab == 3 ? "border-primary bg-primary text-white" : ""
              }`}
          >
            <img
              src={
                matchData?.inn3_team == "IND"
                  ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1126.png"
                  : matchData.inn3_team == "ENG"
                    ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1121.png"
                    : ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${matchData?.inn1_team.toLowerCase()}1.png`
              }
              width={35}
              height={35}
              alt="teama_logo"
            />
            <div className="flex flex-col gap-1 text-sm">
              <span className="flex items-center gap-2">
                <span>{matchData?.inn3_team}</span>
                <span
                  className={`${currentTab == 3 ? "text-white" : ""
                    }rounded-full bg-gray-400 w-1 h-1`}
                ></span>
                <span
                  className={`${currentTab == 3 ? "text-white" : ""
                    } text-gray-500`}
                >
                  {"2nd Inn"}
                </span>
              </span>
              <span>{matchData?.inn3_score || "Yet to Bat"}</span>
            </div>
          </button>
        )}
        {matchData?.inn4_team && (
          <button
            onClick={() => {
              setCurrentTab(4);
              // setActiveCommTab(1);
            }}
            className={`min-w-fit flex items-center gap-2 py-2 px-2 md:px-4 rounded-lg border border-gray-300 ${currentTab == 4 ? "border-primary bg-primary text-white" : ""
              }`}
          >
            <img
              src={
                matchData?.inn4_team == "IND"
                  ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1126.png"
                  : matchData.inn4_team == "ENG"
                    ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/1121.png"
                    : ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${matchData?.inn2_team.toLowerCase()}1.png`
              }
              width={35}
              height={35}
              alt="teamb_logo"
            />
            <div className="flex flex-col gap-1 text-sm">
              <span className="flex items-center gap-2">
                <span>{matchData?.inn4_team}</span>
                <span
                  className={`${currentTab == 4 ? "text-white" : ""
                    } rounded-full bg-gray-400 w-1 h-1`}
                ></span>
                <span
                  className={`${currentTab == 4 ? "text-white" : ""
                    }text-gray-500`}
                >
                  {"2nd Inn"}
                </span>
              </span>
              <span>{matchData?.inn4_score || "Yet to Bat"}</span>
            </div>
          </button>
        )}
      </div>

      {/* commentary  */}
      {commentary?.length > 0 ? (
        <section className="w-full my-4 py-2">
          <h2 className="font-semibold text-lg">Commentary</h2>
          <div className="flex items-center gap-2 my-4">
            {commTabs.map((tab, index) => {
              return (
                <button
                  key={index}
                  onClick={() => {
                    setActiveCommTab(tab.tabNo);
                  }}
                  className={`px-3 py-2 text-center border border-gray-300 rounded-lg ${activeCommTab == tab.tabNo
                    ? "border-primary text-white bg-primary"
                    : ""
                    }`}
                >
                  {tab.tabName}
                </button>
              );
            })}
          </div>
          {commentary?.map((item, index) => {
            return (
              <div key={index}>
                {item.over_summary?.summary?.length &&
                  index == 1 &&
                  scrolled && (
                    <div className="my-3">
                      <AdSlot300x250
                        divId={"div-gpt-ad-1659434785315-0"}
                        minWidth="300px"
                        minHeight="250px"
                      />

                      <AdSlot728x90
                        divId={"div-gpt-ad-1707804176041-3"}
                        minWidth="720px"
                        minHeight="90px"
                      />
                    </div>
                  )}

                {item.over_summary?.summary?.length && index > 0 ? (
                  <div className="flex items-center justify-between my-2 rounded-lg bg-yellow-400 border p-4">
                    <span className="font-semibold">
                      {"Over " + (+item.over_summary?.over + 1)}
                    </span>
                    <div className="w-[80%] md:w-[50%] flex items-center justify-end px-1 gap-2">
                      {item.over_summary?.summary?.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className={`w-8 h-8 p-1 text-center rounded-full  border border-gray-700 text-gray-700 ${item == "4" || item == "6"
                              ? "text-white bg-blue-500"
                              : item == "W"
                                ? "text-white bg-red-500"
                                : "bg-white"
                              }`}
                          >
                            {item}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <></>
                )}
                {item?.balls?.map((ball, index) => {
                  if (ball.runs == null) {
                    return (
                      <div
                        key={index}
                        className="w-full px-2 py-1 border border-gray-300 rounded-lg my-4"
                      >
                        <span>{ball?.commSpeakers}</span>
                        <span className="text-gray-500">
                          {ball?.commHighlight}
                        </span>
                        <span className="text-gray-500">{ball?.comment}</span>
                      </div>
                    );
                  } else
                    return (
                      <div
                        key={index}
                        className="w-full px-2 py-1 border border-gray-300 rounded-lg my-4"
                      >
                        <div className="flex items-start gap-1">
                          <div className="w-[10%] flex flex-col md:flex-row items-center gap-2">
                            <div className="font-semibold">{ball?.ball}</div>
                            <div
                              className={`w-8 p-1 rounded-full text-center text-sm border border-gray-300 ${ball?.runs == "4" || ball?.runs == "6"
                                ? "border-blue-500 bg-blue-500 text-white"
                                : ""
                                } ${ball?.wicket == "Yes"
                                  ? "border-red-500 bg-red-500 text-white"
                                  : ""
                                }`}
                            >
                              {ball?.wicket == "Yes" ? "W" : ball?.runs}
                            </div>
                          </div>

                          <div className="w-[90%] flex flex-col gap-2">
                            <span>{ball?.commSpeakers}</span>
                            <span className="text-gray-500">
                              {ball?.commHighlight}
                            </span>
                            <span className="text-gray-500">
                              {ball?.comment}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                })}
              </div>
            );
          })}
        </section>
      ) : (
        <div className="text-lg w-full text-center my-8 text-gray-500">
          मैच हाइलाइट्स के लिए बने रहें
        </div>
      )}
    </div>
  ) : (
    <div className="w-full flex flex-col items-center justify-center text-lg text-gray-500 mt-10 mb-12">
      <SVG
        src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/NoMatchData.svg"
        className="w-22 h-122 rounded-full mb-4"
      />
      मैच जल्दी शुरू होगा लाइव अपडेट्स के लिए बने रहें
    </div>
  );
};

export default MatchCommentary;
